<template>
  <div class="component-wrapper text_background">
    <Card
      :showCard="showCard"
      :cardColor="'poi_background'"
      topDistance="(100vh - 430px)"
      bottomDistance="600px"
    >
      <template #background="{ step }">
        <div :class="mapContainer(step)">
          <div id="google_map">
            <GmapMap
              :center="{
                lat: parseFloat(currentTour.days[0].pois[0].poi.latitude),
                lng: parseFloat(currentTour.days[0].pois[0].poi.longitude),
              }"
              :zoom="15"
              :options="mapOptions"
              :class="mapStyle(step)"
              ref="mapRef"
              @click="showCard ? (showCard = false) : ''"
            >
              <div>
                <gmap-custom-marker
                  v-for="poi in currentTour.days[0].pois"
                  :key="poi.id"
                  :marker="{
                    lat: parseFloat(poi.poi.latitude),
                    lng: parseFloat(poi.poi.longitude),
                  }"
                  :zIndex="2"
                  class="mt-2"
                >
                  <button @click="onPoiClick(poi.poi, step)">
                    <img
                      v-if="
                        currentPoi && currentPoi.id == poi.poi.id && showCard
                      "
                      src="@/assets/icons/map/Excavation POI Icon_selected.svg"
                      style="height: 32px; width: auto"
                    />
                    <img
                      v-else
                      src="@/assets/icons/map/excavation_poi.svg"
                      style="height: 32px; width: auto"
                    />
                  </button>
                </gmap-custom-marker>

                <gmap-custom-marker
                  :marker="{
                    lat: location.latitude,
                    lng: location.longitude,
                  }"
                  :zIndex="1"
                >
                  <button>
                    <img
                      src="@/assets/icons/map/user-location.svg"
                      style="height: 32px; width: auto"
                    />
                  </button>
                </gmap-custom-marker>
              </div>
            </GmapMap>
          </div>
          <transition name="fade">
            <div
              v-if="!showCard && $vuetify.breakpoint.xs"
              class="poi-header d-flex align-center justify-center"
              :style="buttontop"
            >
              <img
                src="@/assets/icons/excavation.svg"
                style="height: 25px; width: auto"
                class="mr-4"
              />
              <div>{{ $t("tour.select_poi") }}</div>
            </div>
          </transition>

          <div
            v-if="step != 3"
            style="
              z-index: 99;
              row-gap: 8px;
              position: absolute;
              bottom: 20px;
              right: 10px;
            "
            class="d-flex flex-column align-end"
          >
            <button style="margin-top: auto">
              <img
                src="@/assets/icons/map/North Button.svg"
                style="height: 35px; width: auto"
              />
            </button>
            <button @click="recenter">
              <img
                src="@/assets/icons/map/Location Button.svg"
                style="height: 35px; width: auto"
              />
            </button>
          </div>
        </div>
      </template>

      <template #title="{ step }">
        <!-- title container  -->
        <div style="width: 100vw"></div>
        <!-- title -->
        <div :class="titleContainerStyle(step)">
          <div
            v-if="step != 3 && step != 0"
            class="title-text white--text text-center py-1"
            :class="captionStyle(step)"
          >
            {{ currentTour.name }}
          </div>

          <div
            class="title-text white--text text-center"
            :class="titleStyle(step)"
          >
            {{ currentPoi.name }}
          </div>
          <div
            v-if="step != 3"
            class="title-text white--text d-flex justify-center"
            :class="subTitleStyle(step)"
          >
            <!-- {{ currentPoi.subtitle }} -->
          </div>

          <div
            v-if="step == 3"
            class="title-text white--text"
            :class="subTitleStyle(step)"
          >
            {{ currentPoi.subtitle }}
          </div>
        </div>
        <!-- top controllers -->
      </template>

      <template #content="{ step }">
        <div
          v-if="step != 0"
          class="text_background pa-10 d-flex flex-column"
          :class="
            step == 3 && $vuetify.breakpoint.xs
              ? 'expanded'
              : step == 3 && !$vuetify.breakpoint.xs
              ? 'web'
              : ''
          "
        >
          <TextSection
            :item="{
              paragraph: currentPoi.description,
              isLast: true,
            }"
            class="mb-8"
          ></TextSection>

          <Carousel
            v-if="currentPoi.images.length > 0"
            :images="currentPoi.images"
            :initialImage="currentPoi.images[0]"
          ></Carousel>
        </div>
      </template>

      <template #bottomNavigation="{ step }">
        <transition name="fadeInUp">
          <div
            v-if="currentPoi.videos.length > 0"
            :class="
              $vuetify.breakpoint.xs
                ? 'bottom_navigation'
                : 'bottom_navigation web'
            "
            style="z-index: 999"
          >
            <button @click="dialog = true">
              <img
                v-if="step == 2 || step == 3"
                src="@/assets/icons/tour-close.svg"
                style="height: 55px; width: auto"
              />
            </button>
          </div>
        </transition>
      </template>
    </Card>
    <v-overlay z-index="999" v-model="dialog">
      <ModelDialog
        :model="currentPoi.videos"
        v-if="dialog"
        @close="dialog = false"
      />
    </v-overlay>
  </div>
</template>

<script>
import mapStyles from "@/utils/mapStyles.json";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import axios from "axios";
import Card from "@/components/Utils/Card.vue";
import TextSection from "@/components/Utils/TextSection.vue";
import Carousel from "@/components/Utils/Carousel.vue";
import ModelDialog from "@/components/Dialogs/ModelDialog.vue";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Card,
    TextSection,
    Carousel,
    ModelDialog,
    "gmap-custom-marker": GmapCustomMarker,
  },

  beforeRouteEnter(to, from, next) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);

    next();
  },

  async created() {
    try {
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      dialog: false,
      showModel: false,
      showCard: false,
      mapOptions: {
        directionsService: null,
        directionsRenderer: null,
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        gestureHandling: "greedy",
        minZoom: 8,
        maxZoom: 18,
        styles: mapStyles,
      },
      currentPoi: null,
      route: {},
    };
  },

  computed: {
    ...mapState({
      currentTour: (state) => state.routes.currentTour,
      location: (state) => state.base.location,
      insets: (state) => state.base.insets,
    }),

    main() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 0px)`;
    },

    buttontop() {
      return `margin-top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      })`;
    },
  },

  methods: {
    async onPoiClick(poi, step) {
      const res = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/pois/${poi.id}`
      );
      this.showCard = true;

      this.currentPoi = res.data.poi;
    },

    async recenter() {
      try {
        this.$refs.mapRef.panTo({
          lat: this.location.latitude,
          lng: this.location.longitude,
        });
      } catch (e) {
        console.log(e);
      }
    },
    // styling
    mapStyle(step) {
      if (this.showCard) {
        if (step == 3 && !this.$vuetify.breakpoint.xs) return "googleMap";

        if (step == 0) return "googleMap bottom";
        else return "googleMap shrinked";
      }
      return "googleMap";
    },

    mapContainer(step) {
      if (this.showCard) {
        if (step == 3 && !this.$vuetify.breakpoint.xs) return "map-container";
        if (step == 0) return "map-container bottom";
        else return "map-container shrinked";
      }
      return "map-container";
    },

    titleContainerStyle(step) {
      if (step == 3 || step == 0) return "title-container shrinked";
      return "title-container";
    },

    backgroundImageStyle(step) {
      if (step == 3 || step == 0) return "background-image shrinked";
      return "background-image ";
    },

    titleStyle(step) {
      if (step == 3 && !this.$vuetify.breakpoint.xs) return "route_title web";
      if (step == 3 || step == 0) {
        return "route_title shrinked";
      }
      return "route_title";
    },

    subTitleStyle(step) {
      if (step == 3 || step == 0) {
        return "route_subtitle shrinked";
      }
      return "route_subtitle";
    },

    captionStyle(step) {
      return "route_caption";
    },

    // styling

    onOpenMap() {
      this.$router.push(`/routes/pois`);
    },
  },
};
</script>

<style scoped>
.title-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -35%);
}

.title-container.shrinked {
  margin-top: 25px;
  transform: translate(-50%, -60%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.route_title {
  font-weight: 400;
  font-size: 35px;
  transition: font-size 0.5s ease;
  line-height: 40px;
  /* white-space: nowrap; */
  width: 350px;
}

.route_title.shrinked {
  margin-top: 10px;
  font-size: 24px;
  line-height: 35px;
  width: 181px;
}

.route_title.web {
  margin-top: 10px;
  font-size: 24px;
  line-height: 35px;
  width: auto;
}

.route_subtitle {
  font-weight: 300;
  font-size: 23px;
  transition: font-size 0.5s ease;
  line-height: 40px;
  width: 350px;
  text-align: center;
  /* white-space: nowrap; */
}

.route_caption {
  font-weight: 250;
  font-size: 18px;
  transition: font-size 0.5s ease;
  white-space: nowrap;

  /* line-height: 30px; */
}

.map-container {
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  transition: all 0.6s ease;
}

.map-container.shrinked {
  height: 58vh;
}

.map-container.bottom {
  height: 85vh;
}

.text_background.expanded {
  margin-top: 125px;
  /* padding-bottom: 300px; */
}

.text_background.web {
  margin-top: 50px;
  /* padding-bottom: 300px; */
}

.googleMap {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
  height: 100vh;
  transition: all 0.6s ease;
}

.googleMap.shrinked {
  height: 60vh;
}

@keyframes fadeInUp {
  from {
    transform: translate3d(0, 89px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.6s ease;
  transition: opacity 0.6s ease;
}
.fadeInUp-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.poi-header {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  padding: 10px;
  background-color: white;
  font-weight: 500;
  font-size: 18px;
}

.bottom_navigation {
  position: fixed;
  bottom: 15px;
  right: 15px;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
}

.bottom_navigation.web {
  position: absolute;
}
</style>
